import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("TextFooterWidget", {
  title: "Text footer widget",
  properties: ["title", "text"],
});
